import React, { useRef, useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import {
  checkAadhaarAsync,
  fetchAadhaarDetailsAsync,
  selectOTP,
  setOTP,
  setOTPVerified,
} from "../property/AadhaarDetailsSlice"; // Update the path
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AadhaarOTPModal = ({ isOpen, onClose }) => {
  ////;
  const dispatch = useDispatch();
  const inputs = useRef([]);
  const [allFieldsFilled, setAllFieldsFilled] = useState(false);
  const storedOTP = useSelector(selectOTP);
  console.log(selectOTP);

  useEffect(() => {
    if (isOpen && inputs.current.length > 0 && inputs.current[0]) {
      inputs.current[0].focus();
    }
  }, [isOpen]);

  const handleChange = (index, e) => {
    const digit = e.target.value.slice(-1); // Get the last entered digit
    if (/^\d$/.test(digit)) {
      // If the character is a digit, update the current input field with it
      inputs.current[index].value = digit;

      // Move focus to the next empty input field if available
      for (let i = index + 1; i < inputs.current.length; i++) {
        if (inputs.current[i].value === "") {
          inputs.current[i].focus();
          break;
        }
      }
    } else if (digit === "") {
      // If the character is empty (e.g., when Backspace is pressed), keep the focus on the current input field
      inputs.current[index].focus();
    }

    // Check if all input fields are filled in the OTP
    const isOtpFilled = inputs.current.every((input) => input.value !== "");
    setAllFieldsFilled(isOtpFilled);
  };

  const handleKeyDown = (index, e) => {
    if (
      e.key === "Backspace" &&
      index > 0 &&
      inputs.current[index].value === ""
    ) {
      // If Backspace is pressed and the current field is empty, move focus to the previous input field
      inputs.current[index - 1].focus();
    }
  };

  const handleVerifyOTP = () => {
    // Get entered OTP from input fields
    const enteredOTP = inputs.current.map((input) => input.value).join("");

    // Compare with stored OTP
    if (enteredOTP === storedOTP) {
      // OTP matched, perform further actions (e.g., close modal, navigate to next step)
      toast.success("OTP matched!");
      dispatch(setOTPVerified(true));

      onClose(); // Close modal
      // Additional logic here based on your application flow
    } else {
      // Handle OTP mismatch scenario
      console.log("OTP does not match!");
      toast.error("Invalid OTP! Please check");
      // Show error message or handle accordingly
    }
  };

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900"
                >
                  Enter OTP
                </Dialog.Title>
                <div className="mt-2">
                  <div className="mb-4">
                    {[...Array(6)].map((_, index) => (
                      <input
                        key={index}
                        type="text"
                        className="otp-input h-12 w-12 text-center mx-1 border rounded"
                        maxLength="1"
                        onChange={(e) => handleChange(index, e)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                        ref={(el) => (inputs.current[index] = el)}
                      />
                    ))}
                  </div>
                  <button
                    className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded ${
                      allFieldsFilled ? "" : "opacity-50 cursor-not-allowed"
                    }`}
                    disabled={!allFieldsFilled}
                    onClick={handleVerifyOTP}
                  >
                    Verify OTP
                  </button>
                </div>
                <div className="mt-4">
                  <button
                    type="button"
                    className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                    onClick={onClose}
                  >
                    Close
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default AadhaarOTPModal;
